module.exports = __webpack_public_path__ + "static/media/lignt_blue_arrow.ff2098a8.gif";